<template>
    <div class="data-null flex flex-j-c-center flex-a-i-center">
        <img src="@/assets/null.png">
        <p>暂无数据</p>
    </div>
</template>

<script>

export default {
  name: 'DataNull',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.data-null{
    width: 1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FABF01;
    flex-direction: column;
    /* z-index: 999; */
}
.data-null img{
    width: 0.5rem;
    height: 0.5rem;
}
</style>
